<template>
  <div>
    <div class="text-xs-center mb-2">
      <div class="d-flex">
        <div
          style="
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: relative;
          height: 50px;
        "
        >
          <img
            src="@/assets/back-office/icons/chevron_icon_left.svg"
            alt=""
            width="30px"
            @click="$router.back()"
            style="cursor: pointer; margin-left:1vw"
          />
          <div></div>
        </div>
      </div>
    </div>
    <div v-if="this.$route.params.transaction_partner_type == 'Withdraw'">
      <WithdrawDetail />
    </div>
  </div>
</template>

<script>
import WithdrawDetail from "../../../components/back-office/ManagerUserManage/WithdrawDetail.vue";
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  data: {
    loadingMessage: false,
  },
  components: {
    WithdrawDetail,
  },
  methods: {
    ...mapActions({
      fetchtransactionWithdrawBill:
        "fetchUserBack/fetchtransactionWithdrawBill",
    }),
    async getData() {
      if (this.$route.params.transaction_partner_id) {
        let idWithdraw = this.$route.params.transaction_partner_id;
        this.loadingMessage = true;
        await this.fetchtransactionWithdrawBill({
          profit_id: idWithdraw,
        });
        this.loadingMessage = false;
      }
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style></style>
